import styled from "styled-components";

export const SliderWrapper = styled.div`
  padding: 40px 0;
`;

export const SliderTitle = styled.h3`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  display: flex;
  margin: 20px 0 20px;
  @media (max-width: 768.98px) {
    font-size: 32px;
  }
  & img {
    margin-left: 10px;
  }
`;
